module.exports = __webpack_public_path__ + "static/media/Oaknut---Illustration.42d016c5.svg";